import { useEffect, useState } from "react";
import { Clock } from "lucide-react";

function diff(target) {
  const now = new Date();
  const t = new Date(target + "T09:00:00");
  const ms = t - now;
  if (ms <= 0) return null;
  const days = Math.floor(ms / (1000 * 60 * 60 * 24));
  const hours = Math.floor((ms % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  return { days, hours };
}

export default function Countdown({ targetDate, theme = "light" }) {
  const [d, setD] = useState(() => diff(targetDate));

  useEffect(() => {
    setD(diff(targetDate));
    const id = setInterval(() => setD(diff(targetDate)), 60 * 1000);
    return () => clearInterval(id);
  }, [targetDate]);

  if (!targetDate) return null;
  if (!d) {
    return (
      <span
        data-testid="countdown-passed"
        className={`inline-flex items-center gap-2 text-xs uppercase tracking-[0.18em] font-medium ${
          theme === "dark" ? "text-[#E6D6DF]" : "text-[#3A2E6E]"
        }`}
      >
        <Clock className="w-3.5 h-3.5" />
        Date dépassée
      </span>
    );
  }

  const colorClass =
    theme === "dark" ? "text-[#E6D6DF]" : "text-[#3A2E6E]";
  const bgClass =
    theme === "dark"
      ? "bg-white/10 border-white/15"
      : "bg-[#F3EEF4] border-[#DDD7E2]";

  return (
    <div
      data-testid="countdown"
      className={`inline-flex items-center gap-3 px-4 py-2 rounded-full border ${bgClass}`}
    >
      <Clock className={`w-3.5 h-3.5 ${colorClass}`} />
      <span className={`text-xs uppercase tracking-[0.16em] font-medium ${colorClass}`}>
        {d.days > 0 ? `J - ${d.days}` : `${d.hours} h restantes`}
      </span>
    </div>
  );
}
